var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg07(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.34 123.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.34 13.71l-47.83 110H13.59L61.51 19.8H0V0h87.34z",
    fill: "#fff"
  })));
}
Svg07.displayName = '07';
export default Svg07;